import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EDepositFeeSortField,
  IDepositFee,
  PDepositFeeFilter,
} from "src/core/depositFee/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IDepositFeeState {
  depositFees: IDepositFee[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IDepositFeeState = {
  depositFees: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "deposit-fee/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "deposit-fee/FETCH_SUCCEEDED";
const FETCH_FAILED = "deposit-fee/FETCH_FAILED";
const POLLING_START_REQUESTED = "deposit-fee/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "deposit-fee/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IDepositFee[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PDepositFeeFilter;
    pagination: IPagination;
    sorts: ISort<EDepositFeeSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IDepositFeeState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IDepositFeeState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.depositFees = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
